import { formatNumber } from 'helpers/formatters';
import { roundNumber } from 'helpers/numbers';

const ReadOnlyDecimalNumber = ({ n }) => {
  return <span className={n < 0 ? 'text-danger' : ''}>{formatNumber(roundNumber(n, 2))}</span>;
};

export default ReadOnlyDecimalNumber;
